import { ManageMembersModal } from "./ManageMembersModal";
import { CreateChannelModal } from "./CreateChannelModal";
import { InviteModal } from "./InviteModal";
import { DeleteServerModal } from "./DeleteServerModal";
import { LeaveServerModal } from "./LeaveServerModal";
import { EditServerModal } from "./EditServerModal";
import { VoiceCallModal } from "./VoiceCallModal";
import { EnhancedSettingsModal } from "./EnhancedSettingsModal";
import { NotificationsModal } from "./NotificationsModal";
import { PinnedModal } from "./PinnedModal";
import { ThreadsModal } from "./ThreadsModal";
import { FriendsModal } from "./FriendsModal";
import { StatusModal } from "./StatusModal";
import UserProfileModal from "./UserProfileModal";
import CreateServerModal from "./CreateServerModal";
import SettingsModal from "./SettingsModal";
import UserDiscoveryModal from "./UserDiscoveryModal";
import { QuickSwitcherModal } from "./QuickSwitcherModal";
import { AuditLogModal } from "./AuditLogModal";
import { RoleEditorModal } from "./RoleEditorModal";
import { ServerDiscoveryModal } from "./ServerDiscoveryModal";
import { ServerEventsModal } from "./ServerEventsModal";
import { StageModal } from "./StageModal";
import { WebhooksModal } from "./WebhooksModal";
import { ServerTemplatesModal } from "./ServerTemplatesModal";
import { OnboardingModal } from "./OnboardingModal";
import { AutoModModal } from "./AutoModModal";
import { ServerInsightsModal } from "./ServerInsightsModal";
import { ChannelPermissionsModal } from "./ChannelPermissionsModal";
import { SearchModal } from "./SearchModal";
import { EmojiManagerModal } from "./EmojiManagerModal";
import { NotificationPrefsModal } from "./NotificationPrefsModal";
import { GroupDMModal } from "./GroupDMModal";
import { BotCommandsModal } from "./BotCommandsModal";
import { MemberDirectoryModal } from "./MemberDirectoryModal";
import { ReportModal } from "./ReportModal";
import { BookmarksModal } from "./BookmarksModal";
import { AppearanceModal } from "./AppearanceModal";
import { WhatsNewModal, useWhatsNewAutoShow } from "./WhatsNewModal";

export function ModalProvider() {
  useWhatsNewAutoShow();
  return (
    <>
      <ManageMembersModal />
      <CreateChannelModal />
      <InviteModal />
      <AuditLogModal />
      <DeleteServerModal />
      <LeaveServerModal />
      <EditServerModal />
      <VoiceCallModal />
      <EnhancedSettingsModal />
      <NotificationsModal />
      <PinnedModal />
      <ThreadsModal />
      <FriendsModal />
      <StatusModal />
      <UserProfileModal />
      <CreateServerModal />
      <SettingsModal />
      <UserDiscoveryModal />
      <QuickSwitcherModal />
      <RoleEditorModal />
      <ServerDiscoveryModal />
      <ServerEventsModal />
      <StageModal />
      <WebhooksModal />
      <ServerTemplatesModal />
      <OnboardingModal />
      <AutoModModal />
      <ServerInsightsModal />
      <ChannelPermissionsModal />
      <SearchModal />
      <EmojiManagerModal />
      <NotificationPrefsModal />
      <GroupDMModal />
      <BotCommandsModal />
      <MemberDirectoryModal />
      <ReportModal />
      <BookmarksModal />
      <AppearanceModal />
      <WhatsNewModal />
    </>
  );
}
